import { InfoCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'

export type Props = {
  message: string
}
const TooltipIcon = ({ message }: Props) => {
  return <Tooltip title={message}><InfoCircleOutlined /></Tooltip>
}
export default TooltipIcon
